import { useState } from 'react';
import { ScheduledEmailStatus } from '@dealstack/shared/lib/backendClient';
import { useScheduledEmails } from '@dealstack/frontend/app/pages/Project/MIP/hooks/useScheduledEmails.tsx';
import { MantineTabs } from '@dealstack/frontend/shared/components/MantineTabs/MantineTabs.tsx';
import { MantineTabProps } from '@dealstack/frontend/shared/components/MantineTabs/MantineTab.types';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { useRequiredParams } from '@dealstack/frontend/shared/utils/useRequiredParams';
import { AUTOMATED_EMAILS_TABS } from './AutomatedEmails.types';
import { ConfigurationTab } from './ConfigurationTab';
import { ScheduledQueueTab } from './ScheduledQueueTab';

export const AutomatedEmails = () => {
	const tMipManage = useTranslationMipManage();
	const { dealId, mipId: programmeId } = useRequiredParams('dealId', 'mipId');
	const [activeTab, setActiveTab] = useState<AUTOMATED_EMAILS_TABS>(
		AUTOMATED_EMAILS_TABS.CONFIGURATION
	);

	const { data: activeScheduledEmails } = useScheduledEmails({
		dealId,
		programmeId,
		status: ScheduledEmailStatus.ACTIVE,
	});

	const tabsConfig: MantineTabProps<AUTOMATED_EMAILS_TABS>[] = [
		{
			label: tMipManage('automated_emails.tabs.configuration'),
			value: AUTOMATED_EMAILS_TABS.CONFIGURATION,
		},
		{
			label: tMipManage('automated_emails.tabs.scheduled_queue'),
			value: AUTOMATED_EMAILS_TABS.SCHEDULED_QUEUE,
			count: activeScheduledEmails?.length ?? 0,
		},
	];

	return (
		<MantineTabs
			tabs={tabsConfig}
			value={activeTab}
			onTabChange={(value) => setActiveTab(value as AUTOMATED_EMAILS_TABS)}
			onlyDividerBorder
			panels={[
				{
					value: AUTOMATED_EMAILS_TABS.CONFIGURATION,
					content: <ConfigurationTab />,
				},
				{
					value: AUTOMATED_EMAILS_TABS.SCHEDULED_QUEUE,
					content: <ScheduledQueueTab />,
				},
			]}
		/>
	);
};
